var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-header"},[_c('div',{on:{"click":function($event){return _vm.onTapMenuItem({}, 0)}}},[_c('img',{staticClass:"cp-header-logo",attrs:{"src":_vm.menu[_vm.current].mode === 'dark' ? _vm.logo.dark : _vm.logo.light}})]),_vm._v(" "),_c('div',{ref:"menu",staticClass:"cp-header-menu"},[_vm._l((_vm.menu),function(item,i){return _c('div',{key:i,ref:"menuItem",refInFor:true,staticClass:"cp-header-menu-item",class:[
                i === _vm.current ? 'current': '',
                _vm.menu[_vm.current].mode === 'dark' ? 'dark' : ''
            ],style:({
                'margin-left': i === 0 ? '' : '.54rem'
            }),on:{"click":function($event){return _vm.onTapMenuItem(item, i)}}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('div',{staticClass:"cp-header-menu-line",style:({
                'left': _vm.lineSty.left + 'px',
                'transition': 'all .3s ease-out'
            })})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7adcb255","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Header.vue
// module id = null
// module chunks = 